import { Line } from 'vue-chartjs'
import reactiveChartMixin from './mixins/reactiveChart';
import { hexToRGB } from "./utils";

const chartColor = "#FFFFFF";
const gradientChartOptionsConfiguration = {

    legend: {
        display: false
    },

    tooltips: {
        enabled: false
    },

    scales: {
        yAxes: [{

            ticks: {
                fontColor: "#6f6f6f",
                beginAtZero: true,
                min: 0,
                max: 10,
                maxTicksLimit: 10,
                callback: function(value, index, values) {
                    return '';
                }
            },
            gridLines: {
                drawBorder: false,
                display: false,
                zeroLineColor: 'rgba(0,0,0,0.05)',
                color: 'rgba(0,0,0,0.05)'
            }

        }],

        xAxes: [{
            // barPercentage: 1.6,
            gridLines: {
                drawBorder: false,
                color: 'rgba(0,0,0,0.1)',
                zeroLineColor: "transparent",
                display: false,
            },
            ticks: {
                fontColor: "#6f6f6f",
                callback: function(value, index, values) {
                    return '';
                }
            }
        }]
    },
};

export default {
    name: 'line-chart',
    extends: Line,
    mixins: [reactiveChartMixin],
    props: {
        labels: {
            type: [Object, Array],
            description: 'Chart labels. This is overridden when `data` is provided'
        },
        datasets: {
            type: [Object, Array],
            description: 'Chart datasets. This is overridden when `data` is provided'
        },
        data: {
            type: [Object, Array],
            description: 'Chart.js chart data (overrides all default data)'
        },
        color: {
            type: String,
            description: 'Chart color. This is overridden when `data` is provided'
        },
        extraOptions: {
            type: Object,
            description: 'Chart.js options'
        },
        title: {
            type: String,
            description: 'Chart title'
        },
    },
    methods: {
        assignChartData({ data }) {
            let color = this.color || this.fallBackColor;
            const ctx = document.getElementById(this.chartId).getContext('2d');
            let height = document.getElementById(this.chartId).getBoundingClientRect().height * 0.65
            if (height <= 0) height = 80 // If the element is not rendered yet, we get 0 height. Fallback
            //console.log(`${this.chartId} : ${ctx.canvas.height }=> ${height}`)
            const gradientStroke = ctx.createLinearGradient(0, 0, 0, height);
            gradientStroke.addColorStop(0, "#009800");
            gradientStroke.addColorStop(0.25, "#99ff33");
            gradientStroke.addColorStop(0.5, "#faf300");
            gradientStroke.addColorStop(0.75, "#ffc000");
            gradientStroke.addColorStop(1, "#ff0000");

            return {
                labels: this.labels || [],
                datasets: this.datasets ? this.datasets : [{
                    label: this.title || '',

                    borderColor: gradientStroke,
                    pointBorderColor: gradientStroke,
                    pointBackgroundColor: gradientStroke,
                    pointHoverBackgroundColor: gradientStroke,
                    pointHoverBorderColor: gradientStroke,

                    pointRadius: 0,
                    pointHoverRadius: 0,
                    fill: false,
                    borderWidth: 3,
                    data: this.data || data
                }]
            }
        },
        assignChartOptions(initialConfig) {
            let extraOptions = this.extraOptions || {}
            return {
                ...initialConfig,
                ...extraOptions
            };
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.chartData = this.assignChartData({});
            this.options = this.assignChartOptions(gradientChartOptionsConfiguration);
            this.renderChart(this.chartData, this.options);

            this.chartData = this.assignChartData({});
            this.options = this.assignChartOptions(gradientChartOptionsConfiguration);
            this.renderChart(this.chartData, this.options);
        })
    },
    activated() {
        // console.log('activated')
    },
    updated() {
        // console.log('updated')
    }
}
